import { Store } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'

interface DismissOptions {
  duration?: number | undefined
  onScreen?: boolean | undefined
  pauseOnHover?: boolean | undefined
  waitForAnimation?: boolean | undefined
  click?: boolean | undefined
  touch?: boolean | undefined
  showIcon?: boolean | undefined
}

interface TransitionOptions {
  duration?: number | undefined
  timingFunction?:
    | 'ease'
    | 'linear'
    | 'ease-in'
    | 'ease-out'
    | 'ease-in-out'
    | 'step-start'
    | 'step-end'
    | undefined
  delay?: number | undefined
}

interface notificationTypeProp {
  id?: string | undefined
  onRemoval?: ((id: string, removedBy: any) => void) | undefined
  title?: string | React.ReactNode | React.FunctionComponent | undefined
  message: string | React.ReactNode | React.FunctionComponent | undefined
  content?:
    | React.ComponentClass
    | React.FunctionComponent
    | React.ReactNode
    | undefined
  type: 'success' | 'danger' | 'info' | 'default' | 'warning' | undefined
  container?:
    | 'top-full'
    | 'top-left'
    | 'top-right'
    | 'top-center'
    | 'center'
    | 'bottom-full'
    | 'bottom-left'
    | 'bottom-right'
    | 'bottom-center'
  insert?: 'top' | 'bottom' | undefined
  dismiss?: DismissOptions | undefined
  animationIn?: string[] | undefined
  animationOut?: string[] | undefined
  slidingEnter?: TransitionOptions | undefined
  slidingExit?: TransitionOptions | undefined
  touchRevert?: TransitionOptions | undefined
  touchSlidingExit?:
    | {
        fade?: TransitionOptions | undefined
        swipe?: TransitionOptions | undefined
      }
    | undefined
  width?: number | undefined
}

export const notifyPopup = (props: notificationTypeProp) => {
  const defaultNotification = {
    insert: 'top',
    container: 'top-right',
    animationIn: ['animate__animated', 'animate__fadeIn'],
    animationOut: ['animate__animated', 'animate__fadeOut'],
    dismiss: {
      duration: 3000,
      onScreen: true,
      pauseOnHover: true,
      click: true,
      showIcon: true,
    },
  }

  Store.addNotification({ ...defaultNotification, ...props })
}

export default notifyPopup
